import React from 'react'
import Categories from '../navbar/categories';
import Navbar from '../navbar/header';

const Layout = ({ title, page, page2, layoutBgImg }) => {

    const backgroundStyle = {
        backgroundImage: `url(${layoutBgImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'absolute',
        top: 0,
        left: 0,
        animation: 'moveBack 7s ease-in-out forwards',
    };
    const isHomePage = page2 === "home";


    return (
        <div className={`relative w-full overflow-hidden 
        ${isHomePage ? 'h-[280px] lg:h-[360px] xl:h-[420px] xxl:h-[480px] xxxl:h-[580px]'
                : 'h-[320px] lg:h-[480px] xxxl:h-[580px]'}`}>
            <div className="absolute top-0 left-0 w-full h-full 
                            bg-center bg-no-repeat z-[-1]"
                style={backgroundStyle}
            ></div>
            <div className="overlayStyle"></div>

            <div className='z-[30] '>
                <Navbar />
            </div> 

            <div className="relative z-[10]">
                <Categories />
            </div>

            <div className='absolute top-0 flex items-center gap-4 w-full 
                             h-full z-[5] px-4 xxl:px-12 xxxl:px-32 xxxxl:px-64                         
                             xxxxxl:px-[400px] xxxxxxl:px-[650px] justify-center
                             xxxxxxxl:px-[1600px] xxxxxxxxl:px-[2400px]'>
                <h1 className="text-center font-bold text-2xl lg:text-3xl 
                               text-white animate-slide-in-bottom px-4 
                               max-w-[70%] xl:max-w-[55%] mt-16">
                    {page ? page : title}
                </h1>
            </div>

        </div>
    )
}

export default Layout